import React from "react";
import DeliveryMethodGenericSkeleton from "./DeliveryMethodGenericSkeleton";

function DeliveryMethodDetailSkeleton() {
  return (
    <>
      <DeliveryMethodGenericSkeleton />
    </>
  );
}

export default DeliveryMethodDetailSkeleton;
